import { useQuery } from "react-query";
import { fetchAlarmSnapshotPositions } from "../api/LocationApi";

export const useAlarmLatestPositions = (alarmId) => {
  const query = useQuery({
    queryKey: ["alarm-snapshot-positions", alarmId],
    queryFn: fetchAlarmSnapshotPositions,
    enabled: Boolean(alarmId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const byUserId = new Map();
  if (Array.isArray(query.data)) {
    for (const row of query.data) {
      byUserId.set(row.user_id, row);
    }
  }

  return {
    byUserId,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
